module.exports = __webpack_public_path__ + "static/pmalandris-37c3978beef80e8c3f244aa982594c22.jpg";